const DATE_SEPARATOR = '.';
const MAX_DIGITS = 8; // DD + MM + YYYY

export const birthDateFormatter = (value = ''): string => {
  const digits = value.replace(/\D/g, '');
  const truncated = digits.slice(0, MAX_DIGITS);

  const parts: string[] = [];
  if (truncated.length > 0) parts.push(truncated.slice(0, 2));
  if (truncated.length > 2) parts.push(truncated.slice(2, 4));
  if (truncated.length > 4) parts.push(truncated.slice(4, 8));

  return parts.join(DATE_SEPARATOR);
};
